<div class="time" (motnClickOutside)="activeSegment = null">

  <!-- Hour -->
  <div class="segment hour" (click)="openSegment('hour')">
    {{ hour }}
    @if (activeSegment === 'hour') {
      <motn-popover-menu
        [overlayPositions]="overlayPositions"
        [optionGroup]="hourOptions"
        (clickedOption$)="onHourChange($event)"
      ></motn-popover-menu>
    }
  </div>

  <div class="segment colon">:</div>

  <!-- Minute -->
  <div class="segment" (click)="openSegment('minute')">
    {{ minuteDisplay }}
    @if (activeSegment === 'minute') {
      <motn-popover-menu
        [overlayPositions]="overlayPositions"
        [optionGroup]="minuteOptions"
        (clickedOption$)="onMinuteChange($event)"
      ></motn-popover-menu>
    }
  </div>

  <!-- Seconds (optional) -->
  @if (showSeconds) {
    <div class="segment colon">:</div>
    <div class="segment" (click)="openSegment('second')">
      {{ secondDisplay }}
      @if (activeSegment === 'second') {
        <motn-popover-menu
          [overlayPositions]="overlayPositions"
          [optionGroup]="secondOptions"
          (clickedOption$)="onSecondChange($event)"
        ></motn-popover-menu>
      }
    </div>
  }

  <!-- AM / PM -->
  <div class="segment" (click)="openSegment('period')">
    {{ period }}
    @if (activeSegment === 'period') {
      <motn-popover-menu
        [overlayPositions]="overlayPositions"
        [optionGroup]="periodOptions"
        (clickedOption$)="onPeriodChange($event)"
      ></motn-popover-menu>
    }
  </div>

</div>
